module.exports = __webpack_public_path__ + "static/media/email-circle-2color-blue.a5cf31a3.svg";